import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const stockOperationService = {
  getAllStockOperations,
  getStockOperation,
}

const API_URL = API.BASE_URL + '/v1'

export const STOCK_OP_TYPES = ['receive', 'issue', 'transfer', 'adjustment']

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.location) params.location = filter.location
  if (filter?.dateFrom) params.date_from = filter.dateFrom
  if (filter?.dateTo) params.date_to = filter.dateTo
  return params
}

export function getAllStockOperations(opType, filter) {
  return apiHelper(API_URL).get(`/stock-operations/${opType}`, { params: buildParams(filter) })
}
export function getStockOperation(opType, docNo) {
  return apiHelper(API_URL).get(`/stock-operations/${opType}/${docNo}`)
}
